export default {
  homePage: "Startseite",
  close: "Schließen",
  bestSelling: "Bestseller",
  seeAllProduct: "Alle Produkte ansehen",
  quickView: "Schnellansicht",
  addToWishlist: "Zur Wunschliste hinzufügen",
  addToCompare: "Zum Vergleich hinzufügen",
  compare: "Vergleichen",
  addToCart: "In den Warenkorb",
  searchTitle: "Suche",
  searchButton: "Suchen",
  searchPlaceholder: "Hier suchen..",
  checkout: "Zur Kasse",
  viewCart: "Warenkorb ansehen",
  subtotal: "Zwischensumme",
  cartQuantity: "Warenkorb ({count})",
  filter: "Filter",
  sortby: "Sortieren nach",
  showFilters: "Filter anzeigen",
  collection: "Kollektion",
  category: "Kategorie",
  materials: "Materialien",
  stones: "Steine",
  viewResult: "Ergebnis ansehen",
  relatedProducts: "Ähnliche Produkte",
  nextBtn: "Weiter",
  prevBtn: "Zurück",
  byAuthor: "Von {author}",
  articles: "Artikel",
  allArticles: "Alle Artikel",
  recentlyViewed: "Zuletzt angesehen",
  backTohomepage: "Zurück zur Startseite",
  text404: "Diese Seite wurde wahrscheinlich verschoben.",
  latestArticles: "Neueste Artikel",
  all: "Alle",
  searchInBlog: "Im Blog suchen",
  shopCategories: "Kategorien shoppen",
  shopNow: "Jetzt shoppen",
  status: "Status",
  buyNow: "Jetzt kaufen",
  back: "Zurück",
  forgotPassword: "Passwort vergessen?",
  emailAddressPlaceholder: "E-Mail-Adresse",
  passwordPlaceholder: "Passwort",
  firstNamePlaceholder: "Vorname",
  lastNamePlaceholder: "Nachname",
  submit: "Absenden",
  signIn: "Anmelden",
  signOut: "Abmelden",
  createAccount: "Konto erstellen",
  forgotTitle: "Passwort zurücksetzen",
  forgotDesc:
    "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein. Klicken Sie auf Absenden, um Ihr Passwort per E-Mail zu erhalten.",
  loginTitle: "Bestehende Kunden",
  loginDesc: "Melden Sie sich unten bei Ihrem Konto an:",
  registerTitle: "Neue Kunden",
  registerDesc: "Erstellen Sie unten ein Konto:",
  profile: "Profil",
  myOrders: "Meine Bestellungen",
  wishlist: "Wunschliste",
  addedToWishlist: "Zur Wunschliste hinzugefügt",
  compared: "Verglichen",
  product: "Produkt",
  price: "Preis",
  qty: "Menge",
  edit: "Bearbeiten",
  cartEmpty: "Warenkorb leer",
  discountCode: "Rabattcode",
  discountCodePlaceholder: "Promo-Code eingeben",
  applyCoupon: "Gutschein anwenden",
  orderSummary: "Bestellübersicht",
  total: "Gesamtsumme",
  proceedToCheckout: "Weiter zur Kasse",
  acceptPaymentMethods: "Akzeptierte Zahlungsmethoden",
  continueShopping: "Einkauf fortsetzen",
  shoppingCart: "Einkaufswagen",
  companyPlaceholder: "Firmenname",
  streetAddressPlaceholder: "Straßenadresse",
  cityPlaceholder: "Stadt / Ort",
  zipCodePlaceholder: "Postleitzahl",
  phoneNumberPlaceholder: "Telefonnummer",
  shipToDifferentAddress: "An eine andere Adresse liefern?",
  orderNotePlaceholder: "Bestellhinweis (optional)",
  privacyText:
    "Ihre persönlichen Daten werden verwendet, um Ihre Bestellung zu bearbeiten, Ihre Erfahrung auf dieser Website zu unterstützen und für andere Zwecke, wie in unserer",
  privacyPolicy: "Datenschutzrichtlinie",
  returnPolicy: "Rückgaberecht",
  placeOrder: "Bestellung aufgeben",
  yourOrder: "Ihre Bestellung",
  billingDetail: "Rechnungsdetails",
  apply: "Anwenden",
  logInYourAccount: "Melden Sie sich bei Ihrem Konto an",
  shopByTheLook: "Shoppen nach Stil",
  instagramBlockSubtitle:
    "Folgen Sie uns auf Instagram oder markieren Sie uns mit",
  thanksOrder: "Danke für Ihre Bestellung!",
  orderCompleteDesc:
    "Wir bereiten Ihre Bestellung für den Versand vor. Wir benachrichtigen Sie, sobald sie versandt wurde.",
  orderNumber: "Bestellnummer",
  customerInformation: "Kundeninformationen",
  shippingAddress: "Lieferadresse",
  billingAddress: "Rechnungsadresse",
  customerDetails: "Kundendetails",
  deliveryDetail: "Lieferdetails",
  needHelp: "Brauchen Sie Hilfe? Kontaktieren Sie uns",
  policyBanner:
    "Diese Website verwendet Cookies, um sicherzustellen, dass Sie die beste Erfahrung auf unserer Website machen.",
  gotIt: "Verstanden",
  acceptFor: "Akzeptieren für",
  subscribe: "Abonnieren",
  bySubscribingYouAcceptThe: "Durch das Abonnieren akzeptieren Sie die",
  beTheFirstToGetTheLatestNewsAboutTrendsPromotionsAndMuchMore:
    "Seien Sie die Ersten, die die neuesten Nachrichten über Trends, Aktionen und vieles mehr erhalten!",
  newsletter: "Newsletter",
  omara: "OMARA",
  home: "Startseite",
  youHaveSuccessfullySubscribed: "Sie haben sich erfolgreich angemeldet",
  noData: "Keine Daten",
  noImages: "Keine Bilder",
  success: "Erfolg",
  error: "Fehler",
  serverError: "Serverfehler",
  confirmMessage:
    "Die Registrierung war erfolgreich, folgen Sie den Anweisungen in der Ihnen zugesandten E-Mail.",
  recoverPasswordMessage:
    "Formular erfolgreich gesendet, folgen Sie den Anweisungen in der Ihnen zugesandten E-Mail.",
  emailVerifySuccess: "Ihre E-Mail wurde erfolgreich verifiziert",
  passwordRecoverySuccess: "Ihr Passwort wurde erfolgreich wiederhergestellt",
  passwordUpdateSuccess: "Ihr Passwort wurde erfolgreich aktualisiert",
  loading: "Wird geladen",
  blogPageTitle: "Unser Journal",
  blogPageDescription:
    "Es gibt viele Variationen von Lorem Ipsum, aber die meisten wurden in irgendeiner Form verändert.",
  passwordRecovery: "Passwortwiederherstellung",
  pleaseFillTheForm: "Bitte füllen Sie das Formular aus",
  newPassword: "Neues Passwort",
  confirmNewPassword: "Neues Passwort bestätigen",
  recover: "Wiederherstellen",
  catalog: "Katalog",
  showMore: "Mehr anzeigen",
  showLess: "Weniger anzeigen",
  shipping: "Versand",
  shippingDetail: "Versanddetails",
  free: "Kostenlos",
  directBankTransfers: "Direkte Banküberweisungen",
  giftCard: "Geschenkkarte",
  giftCardAmount: "Betrag der Geschenkkarte",
  discount: "Rabatt",
  view: "Ansehen",
  expressCheckout: "Express-Kasse",
  or: "oder",
  allTransactionsAreSecureAndEncrypted:
    "Alle Transaktionen sind sicher und verschlüsselt.",
  yourOrderIsFree: "Ihre Bestellung ist kostenlos, keine Zahlung erforderlich.",
  payment: "Zahlung",
  change: "Ändern",
  shipTo: "Liefern an",
  contact: "Kontakt",
  completeOrder: "Bestellung abschließen",
  estimateDeliveryDate: "Geschätztes Lieferdatum",
  yourMessageIsSent: "Ihre Nachricht wurde gesendet",
  weWillGetBackToYouWithAnAnswerAsSoonAsPossible:
    "Wir werden uns so schnell wie möglich mit einer Antwort bei Ihnen melden.",
  email: "E-Mail",
  birthday: "Geburtstag",
  save: "Speichern",
  changeUserInfoText: "Benutzerdaten aktualisiert",
  updatePassword: "Passwort aktualisieren",
  currentPassword: "Aktuelles Passwort",
  changeUserPasswordText: "Benutzerpasswort aktualisiert",
  yourEmailPreferences: "Ihre E-Mail-Einstellungen",
  selectWhichEmailsYouWouldLikeToReceive:
    "Wählen Sie aus, welche E-Mails Sie erhalten möchten:",
  changePassword: "Passwort ändern",
  updateEmailPreferences: "E-Mail-Einstellungen aktualisieren",
  dateOrdered: "Bestelldatum",
  orderNo: "Bestellnummer",
  returns: "Rückgaben",
  orderTotal: "Bestellsumme",
  orderDetails: "Bestelldetails",
  paymentSummary: "Zahlungsübersicht",
  discountCard: "Rabattkarte",
  tax: "Steuer",
  productDiscount: "Produkt-Rabatt",
  paymentMethod: "Zahlungsmethode",
  deliveryAddress: "Lieferadresse",
  shippingAddresses: "Lieferadressen",
  addNewAddress: "Neue Adresse hinzufügen",
  create: "Erstellen",
  editAddress: "Adresse bearbeiten",
  addressDeleted: "Adresse gelöscht",
  deleteAddress: "Adresse löschen",
  addressAdded: "Adresse hinzugefügt",
  addressEdited: "Adresse bearbeitet",
  orderTracking: "Bestellverfolgung",
  estimatedDelivery: "Geschätzte Lieferung",
  completed: "Abgeschlossen",
  inProgress: "In Bearbeitung",
  next: "Weiter",
  textMeStatusUpdates: "SMS-Updates senden",
  collections: "Kollektionen",
  fromPrice: "Ab {price}",
  enterPromoCode: "Promo-Code eingeben",
  resetAll: "Alles zurücksetzen",
  troubleCreateOrder:
    "Entschuldigung, derzeit gibt es Schwierigkeiten bei der Bestellerstellung.",
  estimatedDeliveryDate: "Geschätztes Lieferdatum",
  orderNotes: "Bestellnotizen",
  deliveryMethod: "Liefermethode",
  selectShippingMethod: "Versandart auswählen",
  filterTitles: {
    collections: "Kollektion",
    categories: "Kategorie",
    materials: "Materialien",
    stones: "Steine",
    headstyles: "Kopfstyles",
    stoneshapes: "Steinformen",
  },
  configurator: {
    item: "Artikel",
    startingAt: "Ab",
    total: "Gesamt",
    addToBag: "In den Warenkorb legen",
    remove: "Entfernen",
    addItem: "Artikel hinzufügen",
    characters: "Zeichen",
    yourDesign: "Dein Design",
    openMap: "Wählen Sie auf der Karte",
    latitude: "Breitengrad",
    longitude: "Längengrad",
    clear: "Löschen",
    clearAll: "Alles löschen",
    addedToWishlist: "Zur Wunschliste hinzugefügt",
    addToWishlist: "Zur Wunschliste hinzufügen",
    compare: "Vergleichen",
    addedToCompareList: "Zur Vergleichsliste hinzugefügt",
    size_guide: "Finde deine Größe",
    outOfStock: "Ausverkauft",
    productDetails: "Produktdetails",
  },
  estimated: "Geschätzt",
  days: "Tage",
  brand: "Marke",
  productDetails: "Produktdetails",
  acceptAll: "Alle akzeptieren",
  selectACountry: "Land auswählen",
  continue: "Weiter",
  shippingMethod: "Versandmethode",
  finalizeAndPay: "Abschließen und Bezahlen",
  createOrderErrorText:
    "Fehler bei der Bestellerstellung. Bitte wenden Sie sich an den Kundendienst.",
  createSessionErrorText:
    "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  // Mollie payment error messages
  molliePaymentError: "Zahlungsverarbeitungsfehler. Bitte versuchen Sie es erneut.",
  mollieInitError: "Zahlungssystem-Initialisierung fehlgeschlagen. Bitte aktualisieren Sie die Seite.",
  mollieScriptLoadError: "Zahlungssystem konnte nicht geladen werden. Bitte überprüfen Sie Ihre Internetverbindung.",
  mollieCardTokenError: "Kartenvalidierung fehlgeschlagen. Bitte überprüfen Sie Ihre Kartendetails.",
  mollieProfileIdError: "Zahlungskonfigurationsfehler. Bitte kontaktieren Sie den Support.",
  mollieInvalidFieldsError: "Ein oder mehrere Felder sind ungültig",
  mollieComponentsNotMountedError: "Nicht alle erforderlichen Komponenten sind geladen, siehe https://docs.mollie.com/guides/mollie-components/reference für weitere Informationen.",
  paymentFailed: "Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut oder verwenden Sie eine andere Zahlungsmethode.",
  paymentPending: "Die Zahlung wird bearbeitet. Bitte warten Sie, während wir Ihre Zahlung verarbeiten.",
  paymentExpired: "Die Zahlungssitzung ist abgelaufen. Bitte versuchen Sie es erneut.",
  // Mollie card form labels and placeholders
  cardHolderName: "Name",
  cardNumber: "Kartennummer",
  expiryDate: "Ablaufdatum",
  cvc: "CVC",
  enterCardholderName: "Karteninhaber eingeben",
  cardNumberPlaceholder: "1234 1234 1234 1234",
  expiryDatePlaceholder: "MM/JJ",
  cvcPlaceholder: "123",
  cart: "Warenkorb",
  review: "Bewertung",
  paymentStatus: "Zahlungsstatus",
  unpaid: "Unbezahlt",
  paid: "Bezahlt",
  refundStarted: "Rückerstattung gestartet",
  refunded: "Erstattet",
  partiallyRefunded: "Teilweise erstattet",
  voided: "Storniert",
  fillTheFormBelow: "Füllen Sie das folgende Formular aus",
  newClients: "Neue Kunden",
  createMyAccount: "Mein Konto erstellen",
  createAnAccountByClickingBelow:
    "Erstellen Sie ein Konto, indem Sie unten klicken und erhalten Sie",
  percentOff: "{percent}% Rabatt",
  yourFirstOrder: "auf Ihre erste Bestellung",
  yourCartIsEmpty: "Ihr Warenkorb ist leer",
  login: "Anmelden",
  sorting: "Sortierung",
  priceFromLowestToHighest: "Preis von niedrig nach hoch",
  priceFromHighestToLowest: "Preis von hoch nach niedrig",
  defaultV: "Standard",
  use: "Verwenden",
  notificationLanguage: "Benachrichtigungssprache",
  onlinePayment: "Online-Zahlung",
  card: "Karte",
  bankTransfer: "Banküberweisung",
  paymentMethodC: "Zahlungsmethode",
  bankTransferDisclaimer:
    "Sie erhalten eine E-Mail mit allen notwendigen Zahlungsdetails.",
  stripeDisclaimer:
    "Ihre Zahlungsinformationen werden sicher von <a href='https://stripe.com/at/resources/more/secure-payment-systems-explained' target='_blank'>Stripe</a> verarbeitet. Wir speichern keine Kartendaten.",
  mollieDisclaimer:
    "Ihre Zahlungsinformationen werden sicher von <a href='https://www.mollie.com/en/security' target='_blank'>Mollie</a> verarbeitet. Wir speichern keine Kartendaten.",
  selectJewelry: "Schmuck auswählen",
  nextStep: "Nächster Schritt",
  gold: "Gold",
  platinum: "950 Platin",
  silver: "925 Silber",
  goldOverSilver: "Vergoldetes Silber",
  recommended: "Empfohlen",
  thePerfectComplement: "Die perfekte Ergänzung",
  description: "Beschreibung",
  shipReturn: "Versand & Rückgabe",
  askAQuestion: "Häufig gestellte Fragen",
  closePopup: "Popup schließen",
  closeFilter: "Filter schließen",
  toggleMenu: "Menü umschalten",
  removeFromComparison: "Aus dem Vergleich entfernen",
  removeFromWishlist: "Von der Wunschliste entfernen",
  closeCartDrawer: "Warenkorb schließen",
  removeDiscount: "Rabatt entfernen",
  openFilePreview: "Dateivorschau öffnen",
  closeSearchPopup: "Such-Popup schließen",
  closeModal: "Modal schließen",
  removeCartItem: "Artikel aus Warenkorb entfernen",
  ariaGoToSlide: "Gehe zu Folie {index}",
  ariaPrevSlide: "Vorherige Folie",
  ariaNextSlide: "Nächste Folie",
  viewThePhotoOnInstagram: "Foto auf Instagram ansehen",
  ariaViewProduct: `Produkt {title} ansehen`,
  ariaBackTo: `Zurück zu {title}`,
  thankYouForSubscription: "Danke für Ihre Anmeldung",
  thankYouForSubscribingExploreOurExclusiveJewelryCollectionsAndStayTunedForUpdates:
    "Vielen Dank für Ihre Anmeldung! Entdecken Sie unsere exklusiven Schmuckkollektionen und bleiben Sie auf dem Laufenden!",
  startShoppingNow: "Jetzt mit dem Einkaufen beginnen",
  didntReceiveYourEmail: "Haben Sie Ihre E-Mail nicht erhalten?",
  checkYourSpamFolderOrContactOurSupport:
    "Überprüfen Sie Ihren Spam-Ordner oder <a href='mailto:info@omara.sk'>kontaktieren Sie unseren Support</a>.",
  dontHaveAnAccountSignUp: "Haben Sie noch kein Konto? Registrieren",
  alreadyHaveAnAccountLogIn: "Haben Sie bereits ein Konto? Anmelden",
  bannerImage: "Bannerbild",
  outOfStock: "Nicht auf Lager",
  requestPrice: "Preis anfragen",
  continueWith: "Weiter mit {title}",
  orSignIn: "Oder anmelden",
  orSignUp: "Oder registrieren",
  remove: "Entfernen",
  discountCodeAndGiftCardsNotice:
    "<span class='tw-font-semibold'>Rabattcodes:</span> Sie können pro Bestellung nur einen Rabattcode anwenden.<br><div class='pt-1'><span class='tw-font-semibold'>Geschenkkarten:</span> Rabattcodes können mit mehreren Geschenkkarten pro Bestellung kombiniert werden.</div>",
  yourAccountHasBeenSuccessfullyCreated: "Ihr Konto wurde erfolgreich erstellt",
  watch: "Ansehen",
  phonePlaceholder: "+49XXXXXXXXX",
  send: "Senden",
  name: "Name",
  campaignsTarget: "Kampagnenziel",
  additionalDetails: "Zusätzliche Details",
  returnItems:
    "Keine zurückgegebenen Artikel | Zurückgegebener Artikel | Zurückgegebene Artikel",
  requestReturn: "Rückgabe beantragen",
  cancel: "Abbrechen",
  refundType: "Rückerstattungstyp",
  writeAFewWords: "Schreiben Sie ein paar Worte",
  reason: "Grund",
  selectReason: "Grund auswählen",
  additionalComment: "Zusätzlicher Kommentar",
  returnAndRefund: "Rückgabe und Rückerstattung",
  repairResize: "Reparatur/Anpassung",
  returnRequested: "Rückgabe beantragt",
  paymentCanceled: "Zahlung abgebrochen",
  paymentTimeoutMessage:
    "Die Zahlung dauert länger als erwartet. Bitte versuchen Sie es erneut.",
  payNow: "Jetzt bezahlen",
  discountCodeIsIncorrect: "Der Rabattcode ist ungültig",
  continueWithoutDiscount: "Ohne Rabatt fortfahren",
  yes: "Ja",
  no: "Nein",
  search: "Suchen",
  readTheArticle: "Artikel lesen",
  nextArticle: "Nächster Artikel",
  topSuggestions: "Top-Vorschläge",
  noResultsFound: "Keine Ergebnisse gefunden",
  noResultsFoundText: "Leider ergab Ihre Suche keine Treffer. Bitte versuchen Sie einen anderen Begriff oder kontaktieren Sie uns",

  // Size to weight translations
  stoneSizeInMm: "Steingröße (mm)",
  caratWeight: "Karatgewicht (kt)",
  selectSize: "Größe auswählen",
  millimetersMmToCaratWeight: "Millimeter zu Karatgewicht",
  hideMmToCaratWeightChart: "Tabelle mm zu Karat ausblenden",
  showMmToCaratWeightChart: "Tabelle mm zu Karat anzeigen",
  mMSize: "Größe in mm",

  // Diamond shapes
  roundCut: "Runder Schliff",
  round: "Rund",
  princessSquareCut: "Princess-Schliff",
  princess: "Princess",
  asscherCut: "Asscher-Schliff",
  asscher: "Asscher",
  cushionCut: "Kissenschliff",
  cushion: "Kissen",
  ovalCut: "Ovaler Schliff",
  oval: "Oval",
  radiantCut: "Radiantschliff",
  radiant: "Radiant",
  pearCut: "Birnenschliff",
  pear: "Birne",
  heartCut: "Herzschliff",
  heart: "Herz",
  marquiseCut: "Marquise-Schliff",
  marquise: "Marquise",
  triangleCut: "Dreiecksschliff",
  triangle: "Dreieck",
  trillionCut: "Trillion-Schliff",
  trillion: "Trillion",
  baguetteStraightCut: " Baguette-Schliff",
  baguette: "Baguette",
  baguetteTaperedCut: "Tapered Baguette-Schliff",
  taperedBaguette: "Tapered Baguette",
  emeraldCut: "Smaragdschliff",
  emerald: "Smaragd",
  articleDescription: "Die neuesten Artikel über",
  ourBlog: "Unser Blog",
  freeShippingByDate: "Kostenloser Versand bis <span class='tw-font-normal'>{date}</span>, bei Bestellung heute",
  freeDaysReturns: "Kostenlose Rückgabe innerhalb von {days} Tagen",
  shippingDateNotAvailable: "Datum nicht verfügbar",
  certificateIssuer: "Zertifikatsaussteller",
  certificateUrl: "Zertifikats-URL",
  finalSale: "Endverkauf",
  nonRefundable: "Nicht erstattungsfähig",
};
